import React, { useCallback, useMemo } from 'react';
import { useMemberListContext, MemberListContext } from '@frontend/app/context/MemberListContext';
import { MembersTableFiltersDrawer } from '@frontend/app/components/MembersTableOld/MembersTableFiltersDrawer/MembersTableFiltersDrawer';
import { IFilter } from '@frontend/app/components';
import { SpecialFilters } from '@frontend/app/constants/specialFilters';

// Custom hook to preserve project-specific filters
export const useProspectsListFilters = () => {
  const { updateFilters: originalUpdateFilters, filters: existingFilters } = useMemberListContext();

  const updateFiltersWithPreservation = useCallback((newFilters: IFilter[]) => {
    // Preserve existing project-specific filters
    const projectSpecificFilters = existingFilters.filter((filter) =>
      filter.column === SpecialFilters.INVITED_PROGRAMS ||
      filter.column === SpecialFilters.SUBMITTED_PROGRAMS ||
      filter.column === SpecialFilters.REJECTED_PROGRAMS ||
      filter.column === SpecialFilters.PROGRAMS
    );

    // Merge project-specific filters with new filters
    const mergedFilters = [...projectSpecificFilters, ...newFilters];
    originalUpdateFilters(mergedFilters);
  }, [existingFilters, originalUpdateFilters]);

  return { updateFilters: updateFiltersWithPreservation };
};

// Custom wrapper that uses the preserved filters hook
export const ProspectsListFiltersDrawer = () => {
  const { updateFilters } = useProspectsListFilters();

  // Override the context's updateFilters function
  const originalContext = useMemberListContext();
  const overriddenContext = useMemo(() => ({
    ...originalContext,
    updateFilters,
  }), [originalContext, updateFilters]);

  return (
    <MemberListContext.Provider value={overriddenContext}>
      <MembersTableFiltersDrawer />
    </MemberListContext.Provider>
  );
};
